import React from 'react'
import { getDocumentHead } from 'components/DocumentHead'
import Analytics from 'components/Organization/Features/Analytics'

export default function AnalyticsPage(): React.ReactElement {
  return <Analytics />
}

export const Head = getDocumentHead({
  title: 'Powerful Analytics',
})
